import styled from '@emotion/styled';
import { Box } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import { InputProps } from './types';

export const InputDivider = styled(Box)<InputProps>`
  position: absolute;
  right: 0;
  bottom: ${(props) => (props.focused ? 0 : themeGet('space.2')(props))};
  top: ${(props) => (props.focused ? 0 : themeGet('space.2')(props))};
  border-right-width: ${(props) => (props.focused ? '2px' : '1px')};
  border-right-color: ${(props) => (props.focused ? themeGet('colors.brand.secondary')(props) : themeGet('colors.greys.alto')(props))};
  border-right-style: solid;
  width: 0px;

  transition: border-right-color ${themeGet('transitions.default')};
`;
